import routineReducerFactory from "./routineReducerFactory";
import {fetchPromotionalModal} from "../actions/routines";

export const promotionalModal = routineReducerFactory(fetchPromotionalModal, {data: [], loading: false});